import { gql } from "@apollo/client";

export const CREATE_BULKEMAIL = gql`
  mutation CreateOrgEmail($input: createOrgEmailInput) {
    createOrgEmail(input: $input) {
      success
      message
    }
  }
`;
